export class MoneyHelper {
    static moneyStringToFloat(string) {
        string = string.toString()
        try {
            if (!string || string == undefined || string == null) return 0
            var match= string.match(/[0-9,.]*/);
            if (match !== null) {
                let replace = match[0].replace(/\./g, '')
                replace = replace.replace(/\,/g, '.')
                return parseFloat(replace); // replace , thousands separator
            }
        } catch(e) {}
        return 0
    }
}